"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthStrategyFactory = void 0;
const app_config_1 = require("../app-config");
const useAuthStrategyFactory = () => {
    const { authStrategy: { authValue, authenticate, loginUrl, getUser } } = (0, app_config_1.getAppConfig)(process.env.REACT_APP_APP_NAME);
    return { authValue, authenticate, getUser, loginUrl };
};
exports.useAuthStrategyFactory = useAuthStrategyFactory;
